<template>
  <div class="relative mt-14 xl:mt-0">
    <span class="font-bold">Chú ý</span>
    <div class="px-4 py-2 rounded-[16px] bg-gray-100 md:h-[280px] lg:overflow-y-auto lg:h-[200px] xl:mr-20">
      <div class="mb-3">
        <h2 class="text-[14px] font-semibold mb-1">1. Trao thưởng</h2>
        <ul class="list-disc font-thin list-inside space-y-1 text-[14px]">
          <li :key="note.id" v-for="note in notSendGift">{{note.value}}</li>
        </ul>
      </div>
      <!-- Section 2 -->
      <div>
        <h2 class="text-[14px] font-bold mb-1">2. Chú ý</h2>
        <ul class="list-disc list-inside space-y-1 font-thin text-[14px]">
          <li :key="note.id" v-for="note in noteSpin">{{note.value}}</li>
        </ul>
      </div>
    </div>
    <div class="hidden absolute top-[-60px] right-[-100px] h-[100px] md:h-[150px] z-[100] xl:block">
      <img class="h-[100px] md:h-[150px]" src="@/assets/images/paper-right.png" alt="">
    </div>
  </div>
</template>

<script>
import {notSendGift, noteSpin} from "@/common/defined";

export default {
  methods: {
  },
  data() {
    return {
      notSendGift, noteSpin,
      baseUrlImage: 'https://ieltsmentor.edu.vn/wp-content/uploads/2024/03/'
    }
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLogin: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>
.label-style {
  @apply uppercase text-[28px] font-black text-[#127AD2] absolute left-1/2 -translate-x-1/2 xl:top-[10px] 2xl:top-[46px]
}

.label-content {
  color: #254696;
}

.text-base-color {
  color: #0446C2;
}
</style>
